export default "__VITE_ASSET__BZsMbEZR__"